// @flow

import React from 'react';
import DocumentCard from '../document-card';
import strings from '../../config/strings';
import { SectionTitle2 } from '../shared/texts/title';
import { policyNoticesListTitle, SectionContainer } from './styles';

type Props = {
  data: any[],
  handleDownloadDocumentClick: Function,
  handleViewDocumentClick: Function,
};

const PolicyNotices = ({
  data = [],
  handleDownloadDocumentClick,
  handleViewDocumentClick,
}: Props) => (
  <SectionContainer>
    <SectionTitle2 style={policyNoticesListTitle}>
      {strings.SECTION_TITLE_POLICY_NOTICES}
    </SectionTitle2>
    {data.length < 1 && (
      <DocumentCard empty emptyClause={strings.NO_ENOTICES} />
    )}
    {data.map(el => (
      <DocumentCard
        documentName={el.description}
        dateAdded={new Date(el.updatedDate).toISOString()}
        docType="enotices"
        handleDownloadDocumentClick={handleDownloadDocumentClick}
        handleViewDocumentClick={handleViewDocumentClick}
        documentPath={el.path}
        key={el.id}
      />
    ))}
  </SectionContainer>
);

export default PolicyNotices;
